// extracted by mini-css-extract-plugin
export default {"limitName":"pkZUg"};